import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Borders() {
  return (
    <ImageCollectionPage 
      title="Borders" 
      path="/borders" 
      collection="borders" 
    />
  );
}
